/**
 * Crypto icons and utilities for ProfileWelcomeCard
 * Shared between mobile and desktop versions
 */

// Crypto icons from Figma - exact URLs from design context (node 322:3134)
// Default icons shown in design (always visible)
export const DEFAULT_BUY_ICONS = [
  { 
    main: 'https://www.figma.com/api/mcp/asset/1e5817ed-c413-4209-a63a-9ca512179682',
    overlay: 'https://www.figma.com/api/mcp/asset/cbdd3d19-5fdf-492c-b303-27259ba4b482'
  },
  { 
    main: 'https://www.figma.com/api/mcp/asset/5197c138-1b9e-4826-95a5-84e48af1fa91'
  },
  { 
    main: 'https://www.figma.com/api/mcp/asset/6e423f0d-4583-4517-b0b3-cbc59c821cd4'
  },
]

export const DEFAULT_SELL_ICONS = [
  { 
    main: 'https://www.figma.com/api/mcp/asset/d802af2b-939e-44b7-a48f-7d57b4ebad4f'
  },
  { 
    main: 'https://www.figma.com/api/mcp/asset/3e1225ac-682e-43f1-a4c4-e05663fd2578'
  },
  { 
    main: 'https://www.figma.com/api/mcp/asset/49004207-a824-428e-9bd2-7eaf4b32a1e7',
    overlay: 'https://www.figma.com/api/mcp/asset/e644e2c5-f174-4d90-af44-5bc4eedf7007',
    overlayPosition: 'inset-[20.55%_28.84%_24.41%_31.02%]'
  },
]

const CRYPTO_ICONS: Record<string, { main: string; overlay?: string; overlay2?: string }> = {
  'bitcoin': { 
    main: 'https://www.figma.com/api/mcp/asset/1e5817ed-c413-4209-a63a-9ca512179682',
    overlay: 'https://www.figma.com/api/mcp/asset/cbdd3d19-5fdf-492c-b303-27259ba4b482'
  },
  'ethereum': { 
    main: 'https://www.figma.com/api/mcp/asset/5197c138-1b9e-4826-95a5-84e48af1fa91'
  },
  'vechain': { 
    main: 'https://www.figma.com/api/mcp/asset/6e423f0d-4583-4517-b0b3-cbc59c821cd4'
  },
  'binance': { 
    main: 'https://www.figma.com/api/mcp/asset/d802af2b-939e-44b7-a48f-7d57b4ebad4f'
  },
  'dogecoin': { 
    main: 'https://www.figma.com/api/mcp/asset/3e1225ac-682e-43f1-a4c4-e05663fd2578'
  },
  'litecoin': { 
    main: 'https://www.figma.com/api/mcp/asset/49004207-a824-428e-9bd2-7eaf4b32a1e7',
    overlay: 'https://www.figma.com/api/mcp/asset/e644e2c5-f174-4d90-af44-5bc4eedf7007'
  },
}

export const getCryptoIcon = (assetName: string): { main: string; overlay?: string; overlay2?: string } | null => {
  const normalized = assetName.toLowerCase().trim()
  // Try exact match first
  if (CRYPTO_ICONS[normalized]) {
    return CRYPTO_ICONS[normalized]
  }
  // Try partial match
  for (const [key, value] of Object.entries(CRYPTO_ICONS)) {
    if (normalized.includes(key) || key.includes(normalized)) {
      return value
    }
  }
  return null
}

